<template>
    <div>

        <p>Paste your data below</p>

        <select v-model="example" @change="loadExample">
            <option>Try sample data</option>
            <optgroup label="Examples">
                <option v-for="(ex, key) in examples" :value="key">{{ ex.title }}</option>
            </optgroup>
        </select>

        <!-- TODO make this an axios command -->
        <form action="/en/dashboards" method="post" enctype="multipart/form-data">

            <input type="hidden" name="_token" :value="csrf">

            <textarea name="csv" v-model="data"
                      class="my-4 w-full h-64 font-mono focus:outline-none rounded bg-grey-lighter w-full focus:bg-white border focus:border-blue-dark"></textarea>

            <button type="submit" class="p-4 text-white border rounded bg-blue-dark">Create Analysis</button>

        </form>


        <p class="mt-2">
            <a class="text-blue-dark" href="/articles/how-to-prepare-csv-formatted-databasestables-for-uploading-to-now-73">
                <i class="fa fa-info"></i> format details
            </a>
        </p>


    </div>
</template>

<script>
    export default {
        name: "ImportCsv",

        data: () => ({
            data: 'date,header 1,header 2,header 3...' + '\n' + '2019,1.0,2.0,3.0...',
            example: null,
            examples: [
                {
                    title: 'Climate change global average surface temperature anomalies 1850-2017',
                    data: "year\tmedian\n" +
                        "1850\t-0.373\n" +
                        "1851\t-0.218\n" +
                        "1852\t-0.228\n" +
                        "1853\t-0.269\n" +
                        "1854\t-0.248\n" +
                        "1855\t-0.272\n" +
                        "1856\t-0.358\n" +
                        "1857\t-0.461\n" +
                        "1858\t-0.467\n" +
                        "1859\t-0.284\n" +
                        "1860\t-0.343\n" +
                        "1861\t-0.407\n" +
                        "1862\t-0.524\n" +
                        "1863\t-0.278\n" +
                        "1864\t-0.494\n" +
                        "1865\t-0.279\n" +
                        "1866\t-0.251\n" +
                        "1867\t-0.321\n" +
                        "1868\t-0.238\n" +
                        "1869\t-0.262\n" +
                        "1870\t-0.276\n" +
                        "1871\t-0.335\n" +
                        "1872\t-0.227\n" +
                        "1873\t-0.304\n" +
                        "1874\t-0.368\n" +
                        "1875\t-0.395\n" +
                        "1876\t-0.384\n" +
                        "1877\t-0.075\n" +
                        "1878\t0.035\n" +
                        "1879\t-0.23\n" +
                        "1880\t-0.227\n" +
                        "1881\t-0.2\n" +
                        "1882\t-0.213\n" +
                        "1883\t-0.296\n" +
                        "1884\t-0.409\n" +
                        "1885\t-0.389\n" +
                        "1886\t-0.367\n" +
                        "1887\t-0.418\n" +
                        "1888\t-0.307\n" +
                        "1889\t-0.171\n" +
                        "1890\t-0.416\n" +
                        "1891\t-0.33\n" +
                        "1892\t-0.455\n" +
                        "1893\t-0.473\n" +
                        "1894\t-0.41\n" +
                        "1895\t-0.39\n" +
                        "1896\t-0.186\n" +
                        "1897\t-0.206\n" +
                        "1898\t-0.412\n" +
                        "1899\t-0.289\n" +
                        "1900\t-0.203\n" +
                        "1901\t-0.259\n" +
                        "1902\t-0.402\n" +
                        "1903\t-0.479\n" +
                        "1904\t-0.52\n" +
                        "1905\t-0.377\n" +
                        "1906\t-0.283\n" +
                        "1907\t-0.465\n" +
                        "1908\t-0.511\n" +
                        "1909\t-0.522\n" +
                        "1910\t-0.49\n" +
                        "1911\t-0.544\n" +
                        "1912\t-0.437\n" +
                        "1913\t-0.424\n" +
                        "1914\t-0.244\n" +
                        "1915\t-0.141\n" +
                        "1916\t-0.383\n" +
                        "1917\t-0.468\n" +
                        "1918\t-0.333\n" +
                        "1919\t-0.275\n" +
                        "1920\t-0.247\n" +
                        "1921\t-0.187\n" +
                        "1922\t-0.302\n" +
                        "1923\t-0.276\n" +
                        "1924\t-0.294\n" +
                        "1925\t-0.215\n" +
                        "1926\t-0.108\n" +
                        "1927\t-0.21\n" +
                        "1928\t-0.206\n" +
                        "1929\t-0.35\n" +
                        "1930\t-0.137\n" +
                        "1931\t-0.087\n" +
                        "1932\t-0.137\n" +
                        "1933\t-0.273\n" +
                        "1934\t-0.131\n" +
                        "1935\t-0.178\n" +
                        "1936\t-0.147\n" +
                        "1937\t-0.026\n" +
                        "1938\t-0.006\n" +
                        "1939\t-0.052\n" +
                        "1940\t0.014\n" +
                        "1941\t0.02\n" +
                        "1942\t-0.027\n" +
                        "1943\t-0.004\n" +
                        "1944\t0.144\n" +
                        "1945\t0.025\n" +
                        "1946\t-0.071\n" +
                        "1947\t-0.038\n" +
                        "1948\t-0.039\n" +
                        "1949\t-0.074\n" +
                        "1950\t-0.173\n" +
                        "1951\t-0.052\n" +
                        "1952\t0.028\n" +
                        "1953\t0.097\n" +
                        "1954\t-0.129\n" +
                        "1955\t-0.19\n" +
                        "1956\t-0.267\n" +
                        "1957\t-0.007\n" +
                        "1958\t0.046\n" +
                        "1959\t0.017\n" +
                        "1960\t-0.049\n" +
                        "1961\t0.038\n" +
                        "1962\t0.014\n" +
                        "1963\t0.048\n" +
                        "1964\t-0.223\n" +
                        "1965\t-0.14\n" +
                        "1966\t-0.068\n" +
                        "1967\t-0.074\n" +
                        "1968\t-0.113\n" +
                        "1969\t0.032\n" +
                        "1970\t-0.027\n" +
                        "1971\t-0.186\n" +
                        "1972\t-0.065\n" +
                        "1973\t0.062\n" +
                        "1974\t-0.214\n" +
                        "1975\t-0.149\n" +
                        "1976\t-0.241\n" +
                        "1977\t0.047\n" +
                        "1978\t-0.062\n" +
                        "1979\t0.057\n" +
                        "1980\t0.092\n" +
                        "1981\t0.14\n" +
                        "1982\t0.011\n" +
                        "1983\t0.194\n" +
                        "1984\t-0.014\n" +
                        "1985\t-0.03\n" +
                        "1986\t0.045\n" +
                        "1987\t0.192\n" +
                        "1988\t0.198\n" +
                        "1989\t0.118\n" +
                        "1990\t0.296\n" +
                        "1991\t0.254\n" +
                        "1992\t0.105\n" +
                        "1993\t0.148\n" +
                        "1994\t0.208\n" +
                        "1995\t0.325\n" +
                        "1996\t0.183\n" +
                        "1997\t0.39\n" +
                        "1998\t0.539\n" +
                        "1999\t0.306\n" +
                        "2000\t0.294\n" +
                        "2001\t0.441\n" +
                        "2002\t0.496\n" +
                        "2003\t0.505\n" +
                        "2004\t0.447\n" +
                        "2005\t0.545\n" +
                        "2006\t0.506\n" +
                        "2007\t0.491\n" +
                        "2008\t0.395\n" +
                        "2009\t0.506\n" +
                        "2010\t0.56\n" +
                        "2011\t0.425\n" +
                        "2012\t0.47\n" +
                        "2013\t0.514\n" +
                        "2014\t0.579\n" +
                        "2015\t0.763\n" +
                        "2016\t0.797\n" +
                        "2017\t0.675"
                }],
        }),

        computed: {
            csrf() {
                return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
            },
        },

        methods: {
            loadExample() {
                this.data = this.examples[this.example].data;
            }
        }
    }
</script>

<style scoped>

</style>
